export const PART_CREATE_REQUEST = 'PART_CREATE_REQUEST'
export const PART_CREATE_SUCCESS = 'PART_CREATE_SUCCESS'
export const PART_CREATE_FAIL = 'PART_CREATE_FAIL'
export const PART_CREATE_RESET = 'PART_CREATE_RESET'

export const PART_LIST_REQUEST = 'PART_LIST_REQUEST'
export const PART_LIST_SUCCESS = 'PART_LIST_SUCCESS'
export const PART_LIST_FAIL = 'PART_LIST_FAIL'
export const PART_LIST_RESET = 'PART_LIST_RESET'

export const PART_DETAILS_REQUEST = 'PART_DETAILS_REQUEST'
export const PART_DETAILS_SUCCESS = 'PART_DETAILS_SUCCESS'
export const PART_DETAILS_FAIL = 'PART_DETAILS_FAIL'
export const PART_DETAILS_RESET = 'PART_DETAILS_RESET'

export const PART_UPDATE_REQUEST = 'PART_UPDATE_REQUEST'
export const PART_UPDATE_SUCCESS = 'PART_UPDATE_SUCCESS'
export const PART_UPDATE_FAIL = 'PART_UPDATE_FAIL'
export const PART_UPDATE_RESET = 'PART_UPDATE_RESET'

export const PART_DELETE_REQUEST = 'PART_DELETE_REQUEST'
export const PART_DELETE_SUCCESS = 'PART_DELETE_SUCCESS'
export const PART_DELETE_FAIL = 'PART_DELETE_FAIL'
export const PART_DELETE_RESET = 'PART_DELETE_RESET'
